// Import LitElement base class and html helper function
import {LitElement, html, css} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import {styleMap} from 'lit/directives/style-map.js';

export class StreamUserHr extends LitElement {
    /**
     * Define properties. Properties defined here will be automatically
     * observed.
     */
    static get properties() {
        return {
            user_name: {type: String},
            max_hr: {type: Number},
            hr: {type: Number},
            percentage_hr: {type: Number},
            calories: {type: Number},
            zones_range: {type: Array},
            user_photo_url: {type: String},
            box_color: {type: Array},
            text_color: {type: Object}
        };
    }

    static get styles() {
        return css`
            .box-0 {
                background: var(--box-0-default);
            }
            .box-1 {
                background: var(--box-1-default);
            }
            .box-2 {
                background: var(--box-2-default);
            }
            .box-3 {
                background: var(--box-3-default);
            }
            .box-4 {
                background: var(--box-4-default);
            }
            .color-0 {
                color: var(--box-0-default);
            }
            .color-1 {
                color: var(--box-1-default);
            }
            .color-2 {
                color: var(--box-2-default);
            }
            .color-3 {
                color: var(--box-3-default);
            }
            .color-4 {
                color: var(--box-4-default);
            }
            .box-disabled {
                background: var(--box-disabled-color);
            }
            .stream-user {
                width: var(--stream-box-width);
                height: var(--stream-box-height);
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: space-between;
                padding: 0;
                background-color: var(--stream-user-background);
                border-radius: var(--stream-user-border-radius);
            }
            .stream-user-left {
                padding: 0.8em 0 0.3em 0.8em;
                flex: 0 1 var(--stream-user-left-width);
            }
            .stream-user-main {
                padding: 0.8em 0 0.8em 0;
                flex: 2 1 auto;
            }
            .stream-user-right {
                padding: 0.6em 0.3em 0.6em 0.3em;
                flex: 1 1 var(--stream-user-right-width);
                line-height: 140%;
                font-size: 1.4em;
                font-weight: bold;
            }
            .stream-userphoto-container {
                width: var(--stream-user-width);
                height: var(--stream-user-width);
                margin: auto;
            }
            .stream-userphoto-circle {
                max-width: 100%;
                width: 100%;
                height: auto;
                display: block;
                padding-top: 100%;
                border-radius: 50%;
                background-position-x: center;
                background-position-y: center;
                background-size: cover;
                border: 1px solid #eeeeee;
            }
            .stream-user-main {
                padding-left: 0.8em;
            }
            .stream-user-main p {
                margin: 0;
                padding: 0;
            }
            .stream-user-main .zones-bar-list {
                display: flex;
                display: -webkit-flex;
                flex-direction: row;
                margin-top: 0.3em;
                margin-bottom: 0;
                padding-left: 0;
            }
            .stream-user-main .zone-bar {
                display: block;
                position: relative;
                padding: 0.12em 0.8em;
                margin-right: 5px;
            }
        `;
    }

    constructor() {
        super();
        this.max_hr = 0;
        this.zones_range = [0,60,70,80,90];
        this.box_color = [{'zone-bar': true, 'box-disabled': true},
                          {'zone-bar': true, 'box-disabled': true},
                          {'zone-bar': true, 'box-disabled': true},
                          {'zone-bar': true, 'box-disabled': true},
                          {'zone-bar': true, 'box-disabled': true}];
        this.text_color = {'color-0': true};
        this.user_name = 'Loading';
        this.percentage_hr = 0;
        this.hr = 0;
        this.calories = 0;
        this.user_photo_url = '/img/user_sagoma.jpg';
    }
    get userPhotoStyles() {
        return { 'background-image': 'url(' + this.user_photo_url + ')' }
    }

    // Custom setter for hr
    set hr(val) {
        let oldVal = this._hr;
        this._hr = val;
        let oldPercentage = this.percentage_hr;
        if (this.max_hr > 0) {
            this.percentage_hr = Math.round((val * 100) / this.max_hr);
        }
        let oldBoxColor = this.box_color;
        let z_index = 0;
        for(var i=1; i < this.zones_range.length; i++){
            if (this.percentage_hr <= this.zones_range[i]){
                break;
            }
            z_index = z_index + 1;
        }
        let zone_key;
        for(var j=0; j < this.zones_range.length; j++) {
            if (j <= z_index) {
                zone_key = 'box-' + j;
                this.box_color[j] = {'zone-bar': true, [zone_key]: true};
            } else {
                this.box_color[j] = {'zone-bar': true, 'box-disabled': true};
            }
        }
        let oldTextColor = this.text_color;
        let new_color = 'color-' + z_index;
        this.text_color = { [new_color]: true };
        this.requestUpdate('hr', oldVal);
        this.requestUpdate('percentage_hr', oldPercentage);
        this.requestUpdate('box_color', oldBoxColor);
        this.requestUpdate('text_color', oldTextColor)
    }

    get hr() { return this._hr; }

    render() {
        return html`
            <div class="stream-user">
                <div class="stream-user-left">
                    <div class="stream-userphoto-container">
                        <div class="stream-userphoto-circle" style="${styleMap(this.userPhotoStyles)}"></div>
                    </div>
                </div>
                <div class="stream-user-main">
                    <p>${this.user_name}</p>
                    <ul class="zones-bar-list">
                        <li class="${classMap(this.box_color[0])}"></li>
                        <li class="${classMap(this.box_color[1])}"></li>
                        <li class="${classMap(this.box_color[2])}"></li>
                        <li class="${classMap(this.box_color[3])}"></li>
                        <li class="${classMap(this.box_color[4])}"></li>
                    </ul>
                </div>
                <div class="stream-user-right"><span class="${classMap(this.text_color)}">${this.hr}</span></div>
            </div>
        `;
    }
}